<template>
     <section class="brand-section brand-section--muted">
      <div class="inner-bound pt60 pb60">
        <div class="brand-docs-grid">
          <div
            v-for="(doc, index) in docs"
            :key="doc.title"
            class="brand-docs-card"
            v-animate="'fadeInLeft'"
          >
            <h3>{{ doc.title }}</h3>
            <ul>
              <li v-for="(item, idx) in doc.content" :key="idx">
                <NuxtLink :to="localePath(item.url)">{{ item.title }}</NuxtLink>
              </li>
            </ul>
            <NuxtLink :to="localePath(doc.url)" class="brand-docs-link">
              <div class="base-arrow">&#8594;</div>
            </NuxtLink>
          </div>
        </div>
      </div>
    </section>
</template>

<script setup>
import { brandConfigs, benefitIcons ,brandThemes, docsBase ,otherTypesBase} from "~/pages/brand/config.ts";

const { t, tm, rt } = useI18n();
const { plainTm } = usePlainTm();

const docs = computed(() =>
  docsBase.map((item, i) => ({
    ...item,
    title: plainTm(`brandPage.docs[${i}].title`) || '',
    url_name: plainTm(`brandPage.docs[${i}].urlName`) || '',
    content: item.content.map((c, j) => ({
      ...c,
      title: plainTm(`brandPage.docs[${i}].content[${j}].title`) || '',
    })),
  }))
);
</script>